import { render, staticRenderFns } from "./AdminPasswordPolicy.vue?vue&type=template&id=4b9f5aac"
import script from "./AdminPasswordPolicy.vue?vue&type=script&lang=ts"
export * from "./AdminPasswordPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports